<template>
  <div v-if="showDiscountConfirm" class="discount-confirm">
    <div class="discount-confirm__mask"></div>
    <div class="discount-confirm__dialog">
      <div class="discount-confirm__header">
        <div class="discount-confirm__countdown">{{ displayRemainingTime }} 后失效</div>
      </div>
      <div class="discount-confirm__content">
        <div class="discount-confirm__title">
          <div class="discount-confirm__title-sub">有言权益升级</div>
          <div class="discount-confirm__title-main">恭喜获得限时红包!</div>
        </div>
        <div class="discount-confirm__cards">
          <div class="discount-confirm__card">
            <div class="discount-confirm__card-price">
              <span class="discount-confirm__card-price-prefix">¥</span>
              <span class="discount-confirm__card-price-value">590</span>
            </div>
            <div class="discount-confirm__card-desc">标准版年度套餐</div>
          </div>
          <div class="discount-confirm__card">
            <div class="discount-confirm__card-price">
              <span class="discount-confirm__card-price-prefix">¥</span>
              <span class="discount-confirm__card-price-value">20</span>
            </div>
            <div class="discount-confirm__card-desc">标准版连续包月</div>
          </div>
          <div class="discount-confirm__card">
            <div class="discount-confirm__card-price">
              <span class="discount-confirm__card-price-prefix">¥</span>
              <span class="discount-confirm__card-price-value">223</span>
            </div>
            <div class="discount-confirm__card-desc">入门版年度套餐</div>
          </div>
          <div class="discount-confirm__card">
            <div class="discount-confirm__card-price">
              <span class="discount-confirm__card-price-prefix">¥</span>
              <span class="discount-confirm__card-price-value">10</span>
            </div>
            <div class="discount-confirm__card-desc">入门版连续包月</div>
          </div>
        </div>
      </div>
      <div class="discount-confirm__footer">
        <Button
          class="discount-confirm__button"
          :size="'default'"
          variant="warning"
          @click="handleClaim"
        >
          立即收下
        </Button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Button from '@rendora/design/components/button/Button.vue';
import dayjs from 'dayjs';
import { storeToRefs } from 'pinia';
import { computed, watch } from 'vue';
import { usePayment } from '../../store';

const showDiscountConfirm = defineModel<boolean>('showDiscountConfirm', { default: false });
const paymentStore = usePayment();
const { discountRemainingTime } = storeToRefs(paymentStore);

const displayRemainingTime = computed(() => {
  return dayjs.duration(discountRemainingTime.value, 'seconds').format('HH:mm:ss');
});

const handleClaim = () => {
  // TODO: 实现收下逻辑
  showDiscountConfirm.value = false;
  paymentStore.updateDiscountAccepted(true);
};

watch(
  () => discountRemainingTime.value,
  (newValue, oldValue) => {
    if (newValue <= 0 && oldValue > 0) {
      showDiscountConfirm.value = true;
      paymentStore.startDiscountCountdown();
    }
  },
);
</script>

<style lang="scss" scoped>
.discount-confirm {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--x-radius-large);
  overflow: hidden;
}

.discount-confirm__mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--x-black-6);
}

.discount-confirm__countdown {
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 10px;
  color: var(--x-white-1);
  background: linear-gradient(90deg, #ff6b40 0%, #ff5c56 100%);
  border-radius: 0 0 var(--x-radius-large) var(--x-radius-large);
}

.discount-confirm__dialog {
  position: relative;
  width: 280px;
  height: 368px;
  display: flex;
  flex-direction: column;
  background: var(--x-white-1);
  border-radius: var(--x-radius-large);
  animation: dialog-scale-in 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  transform-origin: center;
}

@keyframes dialog-scale-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.discount-confirm__header {
  position: relative;
  display: flex;
  justify-content: center;
  height: 48px;
}

.discount-confirm__close {
  position: absolute;
  top: 10px;
  right: 20px;
}

.discount-confirm__content {
  flex: 1;
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.discount-confirm__title {
  text-align: center;
  color: var(--x-text-1);
}

.discount-confirm__title-sub {
  font-size: var(--x-text-14-size);
  line-height: var(--x-text-14-line-height);
}

.discount-confirm__title-main {
  font-size: var(--x-text-20-size);
  line-height: var(--x-text-20-line-height);
  font-weight: var(--x-weight-medium);
}

.discount-confirm__cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-top: 24px;
}

.discount-confirm__card {
  background: var(--x-error-2);
  border-radius: var(--x-radius-medium);
  color: var(--x-error-6);
  padding: 7px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.discount-confirm__card-price-prefix {
  font-size: var(--x-text-14-size);
  line-height: var(--x-text-14-line-height);
}

.discount-confirm__card-price {
  width: 100%;
  text-align: center;
  font-size: var(--x-text-28-size);
  font-weight: var(--x-weight-medium);
  line-height: var(--x-text-28-line-height);
  &::after {
    display: block;
    content: ' ';
    width: 100%;
    border-bottom: 1px dashed var(--x-error-6);
    margin: 4px auto;
  }
}

.discount-confirm__card-desc {
  font-size: var(--x-text-12-size);
  line-height: var(--x-text-12-line-height);
  line-height: 18px;
  text-align: center;
}

.discount-confirm__footer {
  padding: 16px 20px;
  display: flex;
  justify-content: center;
  // height: 76px;
}

.discount-confirm__button {
  width: 100%;
}
</style>
